export var UserConversion = /*#__PURE__*/function (UserConversion) {
  UserConversion["ToCompanyMember"] = "ToCompanyMember";
  UserConversion["ToCompanyManager"] = "ToCompanyManager";
  return UserConversion;
}(UserConversion || {});